import { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import EntryDetailTabPanel from "./EntryDetailTabPanel";
import { useTranslation } from "react-i18next";

/**
 * A component for displaying the details of a selected entry
 * @param {Object} props
 * @param {Object} props.entry - The entry data object
 */
export default function EntryDetail({ entry }) {
  const [tabIndex, setTabIndex] = useState(0);
  const { t } = useTranslation("common");

  return (
    <Box
      sx={{
        flexGrow: 1,
        pl: 2,
        pt: "2px",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Entry #{entry.sequenceNumber} –{" "}
        {entry.rider
          ? `${entry.rider.firstName || ""} ${
              entry.rider.lastName || ""
            }`.trim() || entry.rider.id
          : "-"}{" "}
        on {entry.horse?.name || entry.horse?.id || "-"}
      </Typography>

      <Tabs
        value={tabIndex}
        onChange={(_, val) => setTabIndex(val)}
        sx={{ mt: 2, mb: 2 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label={t("entry.tabs.general")} />
        <Tab label={t("entry.tabs.documents")} />
        <Tab label={t("entry.tabs.classes")} />
        <Tab label={t("entry.tabs.stabling")} />
        <Tab label={t("entry.tabs.refunds")} />
        <Tab label={t("entry.tabs.addons")} />
      </Tabs>

      <Box
        sx={{
          flexGrow: 1,
          maxHeight: "calc(100vh - 250px)",
        }}
      >
        <EntryDetailTabPanel entry={entry} tabIndex={tabIndex} />
      </Box>
    </Box>
  );
}
